import { DatePicker, Form, Input, Select } from "antd";
import { filterOption, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useLoaderData, useParams } from "react-router";
import SimpleEditFormPage from "../common/SimpleFormPage";
import dayjs from "dayjs";

export default function () {
  const { id } = useParams();
  const [types, setTypes] = useState([]);
  const data = useLoaderData();

  const loadFn = (form) => form.setFieldsValue({ ...data, type: data.type.id });

  useEffect(() => {
    axiosInstance
      .get("vehicleType", { params: { pageSize: 9999 } })
      .then(({ data }) => setTypes(data.data.map((x) => ({ label: x.name, value: x.id }))));
  }, []);

  return (
    <SimpleEditFormPage
      reactRouter
      path={`vehicle/${id}`}
      title="Modifica veicolo"
      loadFn={loadFn}
    >
      <Form.Item label="Categoria" rules={[requiredField]} name="type">
        <Select options={types} showSearch filterOption={filterOption} />
      </Form.Item>
      <Form.Item label="Targa" rules={[requiredField]} name="plate">
        <Input />
      </Form.Item>
      <Form.Item label="Descrizione" rules={[requiredField]} name="description">
        <Input />
      </Form.Item>
      <Form.Item
        label="Data ultima ispezione (oppure data di acquisto)"
        name="firstInspectionDate"
        getValueProps={(value) => ({ value: value && dayjs(value) })}
        normalize={(value) => value && value.format("YYYY-MM-DD")}
      >
        <DatePicker format={"DD-MM-YYYY"} />
      </Form.Item>
    </SimpleEditFormPage>
  );
}
